<template>
  <div class="inline-flex justify-center items-center gap-x-6">
    <CustomButton
      v-if="!url"
      variant="primary"
      :busy="loading"
      @click="create"
    >
      {{ $t('pages.licenseList.modal.createButton') }}
    </CustomButton>
    <a
      v-else
      :href="url"
      :download="download?.file?.originalFileName"
    >
      <CustomButton
        variant="primary"
        :busy="loading"
      >
        {{ $t('pages.licenseList.modal.downloadButton') }}
      </CustomButton>
    </a>
  </div>
</template>

<script lang="ts" setup>
import { fetchApiBase, useFetchAction } from '@hooks/fetch';
import { useNotify } from '@utils/notifications';
import { useI18n } from 'vue-i18n';
import { ref } from 'vue';
import type { Download, LicenseSeat } from '@/entities/Entities';

interface Props {
  seat: LicenseSeat;
}

const props = defineProps<Props>();

const [exec, { loading }] = useFetchAction();

const notify = useNotify();
const { t } = useI18n();

const download = ref<Download>();
const url = ref('');

const create = async () => {
  try {
    download.value = await exec(`/license_seats/${props.seat.id}/qr-pdf`, {
      method: 'GET',
    });
    if (!download.value?.file?.contentUrl) {
      throw new Error('');
    }
    loading.value = true;
    const response = await fetchApiBase(download.value.file.contentUrl);
    const blob = await response.blob();
    url.value = URL.createObjectURL(blob);
    loading.value = false;
  } catch (e) {
    loading.value = false;
    notify?.({
      variant: 'error',
      title: t('errors.serverError'),
    });
  }
};
</script>

<style lang="scss" scoped>
</style>
